export const translations = {
  en: {
    nav: {
      services: "Services",
      serviceArea: "Service Area",
      testimonials: "Testimonials",
      about: "About",
      contact: "Contact",
      requestService: "Request Service",
    },
    hero: {
      badge: "24/7 EMERGENCY SERVICE",
      title: "Houston's Premier Locksmith",
      titleLine1: "Houston Locks",
      titleHighlight: "the most prestigious",
      titleLine2: "locksmiths in the city",
      subtitle: "Professional locksmith services for residential, commercial, and automotive needs. Fast response, reliable results.",
      cta: "Request Service Now",
      ctaSecondary: "Get Help Fast",
    },
    services: {
      badge: "OUR SERVICES",
      title: "Complete Locksmith Solutions",
      subtitle: "From emergency lockouts to high-security installations, we provide comprehensive locksmith services across Houston.",
      emergency: {
        title: "Emergency Lockout",
        desc: "Locked out? We arrive in 15-30 minutes, 24/7. Fast, damage-free entry for homes, businesses, and vehicles.",
      },
      residential: {
        title: "Residential",
        desc: "Lock changes, rekeying, deadbolt installation, smart locks, and complete home security solutions.",
      },
      commercial: {
        title: "Commercial",
        desc: "Master key systems, access control, high-security locks, panic bars, and commercial door hardware.",
      },
      automotive: {
        title: "Automotive",
        desc: "Car key replacement, transponder programming, ignition repair, and locked-out vehicle assistance.",
      },
      safes: {
        title: "Safes & Vaults",
        desc: "Safe opening, combination changes, safe installation, and vault lock services for homes and businesses.",
      },
      security: {
        title: "Security Upgrades",
        desc: "Security assessments, smart lock installation, keyless entry systems, and complete security overhauls.",
      },
    },
    serviceArea: {
      badge: "SERVICE AREA",
      title: "Serving Greater Houston",
      subtitle: "We proudly serve Houston and all surrounding areas within a 100-mile radius.",
      radius: "100-Mile Service Radius",
      cities: "Including: Katy, Sugar Land, The Woodlands, Pearland, Pasadena, League City, Conroe, Galveston, Baytown, Missouri City, and more.",
      response: "Average Response Time",
      responseTime: "15-30 min",
      available: "Availability",
      availableTime: "24/7/365",
      coverage: "Coverage Area",
      coverageValue: "100+ Miles",
    },
    form: {
      badge: "REQUEST SERVICE",
      title: "Need a Locksmith?",
      subtitle: "Fill out the form below and we'll get back to you immediately. Fast response guaranteed.",
      name: "Full Name",
      namePlaceholder: "John Doe",
      phone: "Phone Number",
      phonePlaceholder: "(936) 249-8196",
      location: "Your Location",
      locationPlaceholder: "Address or cross streets in Houston area",
      problemType: "Type of Service",
      problemPlaceholder: "Select a service type",
      vehicleModel: "Vehicle Make & Model",
      vehiclePlaceholder: "e.g., 2023 Toyota Camry",
      description: "Additional Details",
      descriptionPlaceholder: "Describe your situation...",
      submit: "Send Request",
      submitting: "Sending...",
      success: "Request received! Here's how to reach us for immediate assistance:",
      error: "Something went wrong. Please try again.",
      responseNote: "Average response time: 15-30 minutes",
      callNow: "Call Now",
      whatsapp: "WhatsApp",
      types: {
        emergency: "Emergency Lockout",
        residential: "Residential Service",
        commercial: "Commercial Service",
        automotive: "Automotive Service",
        safes: "Safes & Vaults",
        security: "Security Upgrade",
      },
    },
    testimonials: {
      badge: "TESTIMONIALS",
      title: "Trusted by Houstonians",
      items: [
        { name: "Maria G.", text: "Locked out at 2 AM and they arrived in 20 minutes. Professional and quick. Highly recommend!", rating: 5 },
        { name: "James T.", text: "Had all locks changed in my new home. Excellent work, fair pricing, and very knowledgeable about security.", rating: 5 },
        { name: "Robert K.", text: "Lost my car keys and they made a new one on the spot. Saved me from an expensive dealer visit.", rating: 5 },
        { name: "Sarah L.", text: "Installed a complete access control system for our office. Top-notch commercial service.", rating: 5 },
      ],
    },
    about: {
      badge: "ABOUT US",
      title: "Houston Pro Locksmith",
      text1: "With over 15 years of experience serving the Houston metropolitan area, we are your trusted partner for all locksmith needs. Our team of licensed, bonded, and insured professionals is committed to providing fast, reliable service at fair prices.",
      text2: "We understand that locksmith emergencies don't follow a schedule. That's why we're available 24 hours a day, 7 days a week, 365 days a year. Whether you're locked out of your home at midnight or need a commercial security upgrade, we're here for you.",
      stats: {
        years: "15+",
        yearsLabel: "Years Experience",
        clients: "10,000+",
        clientsLabel: "Happy Clients",
        response: "15 min",
        responseLabel: "Avg. Response",
        available: "24/7",
        availableLabel: "Always Available",
      },
    },
    footer: {
      tagline: "Professional locksmith services for the greater Houston area. Licensed, bonded, and insured.",
      quickLinks: "Quick Links",
      contactInfo: "Contact Info",
      address: "Houston, TX & Surrounding 100 Miles",
      email: "info@houstonprolocksmith.com",
      hours: "Open 24/7 — Emergency Service Available",
      rights: "All rights reserved.",
    },
    admin: {
      login: "Admin Login",
      email: "Email",
      password: "Password",
      loginBtn: "Sign In",
      dashboard: "Service Requests Dashboard",
      logout: "Logout",
      backToSite: "Back to Site",
      noRequests: "No service requests yet.",
      status: "Status",
      date: "Date",
      pending: "Pending",
      contacted: "Contacted",
      completed: "Completed",
    },
  },
  es: {
    nav: {
      services: "Servicios",
      serviceArea: "Área de Servicio",
      testimonials: "Testimonios",
      about: "Nosotros",
      contact: "Contacto",
      requestService: "Solicitar Servicio",
    },
    hero: {
      badge: "SERVICIO DE EMERGENCIA 24/7",
      title: "Cerrajería Premier en Houston",
      titleLine1: "Houston Locks",
      titleHighlight: "los cerrajeros",
      titleLine2: "más prestigiosos de la ciudad",
      subtitle: "Servicios profesionales de cerrajería para necesidades residenciales, comerciales y automotrices. Respuesta rápida, resultados confiables.",
      cta: "Solicitar Servicio Ahora",
      ctaSecondary: "Obtener Ayuda Rápida",
    },
    services: {
      badge: "NUESTROS SERVICIOS",
      title: "Soluciones Completas de Cerrajería",
      subtitle: "Desde emergencias de cerraduras hasta instalaciones de alta seguridad, proporcionamos servicios integrales de cerrajería en todo Houston.",
      emergency: {
        title: "Emergencias",
        desc: "¿Encerrado afuera? Llegamos en 15-30 minutos, 24/7. Entrada rápida y sin daños para hogares, negocios y vehículos.",
      },
      residential: {
        title: "Residencial",
        desc: "Cambio de cerraduras, re-codificación, instalación de cerrojos, cerraduras inteligentes y soluciones completas de seguridad.",
      },
      commercial: {
        title: "Comercial",
        desc: "Sistemas de llave maestra, control de acceso, cerraduras de alta seguridad, barras antipánico y herrajes comerciales.",
      },
      automotive: {
        title: "Automotriz",
        desc: "Reemplazo de llaves de auto, programación de transponder, reparación de encendido y asistencia vehicular.",
      },
      safes: {
        title: "Cajas Fuertes",
        desc: "Apertura de cajas fuertes, cambio de combinaciones, instalación y servicios de bóvedas para hogares y negocios.",
      },
      security: {
        title: "Mejoras de Seguridad",
        desc: "Evaluaciones de seguridad, instalación de cerraduras inteligentes, sistemas de entrada sin llave y renovaciones completas.",
      },
    },
    serviceArea: {
      badge: "ÁREA DE SERVICIO",
      title: "Sirviendo al Gran Houston",
      subtitle: "Servimos con orgullo a Houston y todas las áreas circundantes dentro de un radio de 100 millas.",
      radius: "Radio de Servicio de 100 Millas",
      cities: "Incluyendo: Katy, Sugar Land, The Woodlands, Pearland, Pasadena, League City, Conroe, Galveston, Baytown, Missouri City, y más.",
      response: "Tiempo Promedio de Respuesta",
      responseTime: "15-30 min",
      available: "Disponibilidad",
      availableTime: "24/7/365",
      coverage: "Área de Cobertura",
      coverageValue: "100+ Millas",
    },
    form: {
      badge: "SOLICITAR SERVICIO",
      title: "¿Necesita un Cerrajero?",
      subtitle: "Complete el formulario y nos comunicaremos de inmediato. Respuesta rápida garantizada.",
      name: "Nombre Completo",
      namePlaceholder: "Juan Pérez",
      phone: "Número de Teléfono",
      phonePlaceholder: "(936) 249-8196",
      location: "Su Ubicación",
      locationPlaceholder: "Dirección o calles en el área de Houston",
      problemType: "Tipo de Servicio",
      problemPlaceholder: "Seleccione un tipo de servicio",
      vehicleModel: "Marca y Modelo del Vehículo",
      vehiclePlaceholder: "ej., 2023 Toyota Camry",
      description: "Detalles Adicionales",
      descriptionPlaceholder: "Describa su situación...",
      submit: "Enviar Solicitud",
      submitting: "Enviando...",
      success: "¡Solicitud recibida! Así puede contactarnos para asistencia inmediata:",
      error: "Algo salió mal. Por favor intente de nuevo.",
      responseNote: "Tiempo promedio de respuesta: 15-30 minutos",
      callNow: "Llamar Ahora",
      whatsapp: "WhatsApp",
      types: {
        emergency: "Emergencia",
        residential: "Servicio Residencial",
        commercial: "Servicio Comercial",
        automotive: "Servicio Automotriz",
        safes: "Cajas Fuertes",
        security: "Mejora de Seguridad",
      },
    },
    testimonials: {
      badge: "TESTIMONIOS",
      title: "Confianza de los Houstonenses",
      items: [
        { name: "María G.", text: "Me quedé encerrada a las 2 AM y llegaron en 20 minutos. Profesionales y rápidos. ¡Muy recomendados!", rating: 5 },
        { name: "Jaime T.", text: "Cambié todas las cerraduras de mi nueva casa. Excelente trabajo, precios justos y muy conocedores de seguridad.", rating: 5 },
        { name: "Roberto K.", text: "Perdí las llaves de mi auto y me hicieron una nueva en el momento. Me ahorraron una visita costosa al concesionario.", rating: 5 },
        { name: "Sara L.", text: "Instalaron un sistema completo de control de acceso para nuestra oficina. Servicio comercial de primera.", rating: 5 },
      ],
    },
    about: {
      badge: "SOBRE NOSOTROS",
      title: "Houston Pro Locksmith",
      text1: "Con más de 15 años de experiencia sirviendo al área metropolitana de Houston, somos su socio de confianza para todas las necesidades de cerrajería. Nuestro equipo de profesionales licenciados, con fianza y asegurados está comprometido a brindar un servicio rápido y confiable a precios justos.",
      text2: "Entendemos que las emergencias de cerrajería no siguen un horario. Por eso estamos disponibles las 24 horas del día, los 7 días de la semana, los 365 días del año. Ya sea que esté encerrado afuera de su casa a medianoche o necesite una mejora de seguridad comercial, estamos aquí para usted.",
      stats: {
        years: "15+",
        yearsLabel: "Años de Experiencia",
        clients: "10,000+",
        clientsLabel: "Clientes Satisfechos",
        response: "15 min",
        responseLabel: "Resp. Promedio",
        available: "24/7",
        availableLabel: "Siempre Disponible",
      },
    },
    footer: {
      tagline: "Servicios profesionales de cerrajería para el gran área de Houston. Licenciados, con fianza y asegurados.",
      quickLinks: "Enlaces Rápidos",
      contactInfo: "Información de Contacto",
      address: "Houston, TX y alrededores de 100 millas",
      email: "info@houstonprolocksmith.com",
      hours: "Abierto 24/7 — Servicio de Emergencia Disponible",
      rights: "Todos los derechos reservados.",
    },
    admin: {
      login: "Acceso Administrador",
      email: "Correo Electrónico",
      password: "Contraseña",
      loginBtn: "Iniciar Sesión",
      dashboard: "Panel de Solicitudes de Servicio",
      logout: "Cerrar Sesión",
      backToSite: "Volver al Sitio",
      noRequests: "Aún no hay solicitudes de servicio.",
      status: "Estado",
      date: "Fecha",
      pending: "Pendiente",
      contacted: "Contactado",
      completed: "Completado",
    },
  },
};
